import uuidv4 from 'uuid/v4';

function parseObjectFromString(hashOrQueryString = '') {
  return hashOrQueryString
    .substring(1)
    .split('&')
    .reduce((params, pair) => {
      const [key, value] = pair.split('=');
      return value ? Object.assign({ [key]: value }, params) : params;
    }, {});
}

function queryParser() {
  const hashParams = parseObjectFromString(window.location.hash);
  const queryParams = parseObjectFromString(window.location.search);

  return {
    testCustomerDetails: hashParams.testCustomerDetails || queryParams.testCustomerDetails,
    accessToken: hashParams.access_token,
    amount: hashParams.amount,
    amountConsolidate: hashParams.amountConsolidate,
    bankId:
      hashParams.bankId ||
      hashParams.bank_id ||
      queryParams.bankId ||
      queryParams.bank_id ||
      hashParams.bankid, // Mobile App send's bank ID with `bankid` parameter name as per interface contract.
    brandId: 'VM',
    caseId: hashParams.caseId || hashParams.case_id,
    customerId: hashParams.customer_uuid,
    day: hashParams.day,
    debtConsolidate: hashParams.debtConsolidate,
    eligibilityTime: hashParams.eligibilityTS,
    isJoint: hashParams.isJoint,
    jointLinkCode: queryParams.jointLinkCode || hashParams.jointLinkCode,
    loanType: queryParams.loanType || hashParams.loanType,
    origin: hashParams.origin || queryParams.origin,
    purpose: hashParams.purpose,
    jointBankId: queryParams.jointBankId,
    referrer: hashParams.referrer,
    sourceId:
      hashParams.sourceId ||
      hashParams.source_id ||
      queryParams.sourceId ||
      queryParams.source_id ||
      hashParams.sourceid,
    term: hashParams.term,
    type: hashParams.type,
    upiTS: hashParams.upiTS,
    originBrandId: hashParams.brand_id && hashParams.brand_id.toLowerCase(),
    userTrackingId: hashParams.user_tracking_id || queryParams.user_tracking_id || uuidv4(),
    skipDecisionInPrinciple: hashParams.skip_dip_process || queryParams.skip_dip_process,
    endUserIp: hashParams.end_user_ip || queryParams.end_user_ip,
    stub: hashParams.stub || queryParams.stub
  };
}

export { queryParser };
